import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'nf-save-confirm-modal',
  template: `
    <div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">
        Are you sure you want to re-flag closed issues?
      </h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        ngbTooltip="Close"
        (click)="activeModal.close()"
      >
        Close
      </button>
    </div>
    <div class="modal-body" hsDraggable="modal-dialog">
      <p>
        This will force any existing issues for this corporate action that have
        been resolved to re-flag.
      </p>
    </div>
    <div class="modal-footer" hsDraggable="modal-dialog">
      <button nf-button="cancel" (click)="activeModal.close()"></button>
      <button nf-button="submit" (click)="activeModal.close(true)"></button>
    </div>
  `,
})
export class CorporateActionSaveConfirmationModal {
  constructor(public activeModal: NgbActiveModal) {}
}
